export const ProofTypeOptions = [
  {
    value: 1,
    label: "Proof of Identity",
    subTypeOptions: [
      { value: 1, label: "International Passport" },
      { value: 2, label: "Driver License -- Front" },
      { value: 3, label: "Driver License -- Back" },
    ],
  },
  {
    value: 2,
    label: "Proof of Residence",
    subTypeOptions: [{ value: 4, label: "Credit Card Statement" }],
  },
  {
    value: 3,
    label: "Corporate Certificate",
    subTypeOptions: [{ value: 5, label: "Certificate Of Incorporation" }],
  },
  {
    value: 4,
    label: "Corporate",
    subTypeOptions: [
      { value: 6, label: "Company Extract" },
      { value: 7, label: "Memorandum" },
      { value: 8, label: "Articles Of Association," },
      { value: 9, label: "Certificate Of Incumbency" },
      { value: 10, label: "Other" },
    ],
  },
];

export const documentTypes = {
  1: "Proof of Identity",
  2: "Proof of Residence",
  3: "Corporate Certificate",
  4: "Corporate",
};

export const positionTypes = { 1: "Director", 2: "Shareholder" };

export const documentSubTypes = {
  1: "International Passport",
  2: "Driver License -- Front",
  3: "Driver License -- Back",
  4: "Credit Card Statement",
  5: "Certificate Of Incorporation",
  6: "Company Extract",
  7: "Memorandum",
  8: "Articles Of Association",
  9: "Certificate Of Incumbency",
  10: "Other",
  11: "Constitution / Memorandum and Articles of Association",
  12: "Register of Directors",
  13: "Register of Shareholders/Directors",
  14: "Latest Audited Financial Statement",
};
